import { Badge } from "@/components/ui/badge";
import { FileText, User, Building2, Globe, Search, Loader2 } from "lucide-react";

export const ProspectExpandedDetails = ({ company, details, isLoading }) => (
  <div className="border-t border-gray-700 bg-black/20 p-4">
    <h5 className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
      <FileText className="h-4 w-4 text-[text-ism-teal]" />
      Extended Information
    </h5>

    {company.snippet && (
      <div className="mb-4">
        <p className="text-xs text-gray-500 mb-1">Description</p>
        <p className="text-gray-300 text-sm">{company.snippet}</p>
      </div>
    )}

    <div className="grid grid-cols-2 gap-4 mb-4">
      {company.personName && (
        <div>
          <p className="text-xs text-gray-500 mb-1 flex items-center gap-1"><User className="h-3 w-3" /> Contact</p>
          <p className="text-white text-sm">{company.personName}</p>
          {company.personTitle && <p className="text-gray-400 text-xs">{company.personTitle}</p>}
        </div>
      )}
      {company.companyName && (
        <div>
          <p className="text-xs text-gray-500 mb-1 flex items-center gap-1"><Building2 className="h-3 w-3" /> Company</p>
          <p className="text-white text-sm">{company.companyName}</p>
        </div>
      )}
      {company.url && (
        <div>
          <p className="text-xs text-gray-500 mb-1 flex items-center gap-1"><Globe className="h-3 w-3" /> Source</p>
          <a href={company.url} target="_blank" rel="noopener noreferrer" className="text-[text-ism-teal] text-xs hover:underline break-all">{company.url}</a>
        </div>
      )}
      <div>
        <p className="text-xs text-gray-500 mb-1">Source Type</p>
        <Badge className={`${company.source === "linkedin" ? "bg-ism-teal/20 text-ism-teal" : "bg-gray-500/20 text-gray-400"} text-xs`}>
          {company.source === "linkedin" ? "LinkedIn" : "Web"}
        </Badge>
      </div>
    </div>

    {details?.additionalInfo?.length > 0 && (
      <div>
        <p className="text-xs text-gray-500 mb-2 flex items-center gap-1"><Search className="h-3 w-3" /> Additional Research</p>
        <div className="space-y-2">
          {details.additionalInfo.map((info, infoIdx) => (
            <div key={info.url || info.title || infoIdx} className="bg-white/5 rounded p-2">
              <a href={info.url} target="_blank" rel="noopener noreferrer" className="text-[text-ism-teal] text-xs hover:underline font-medium">{info.title}</a>
              {info.snippet && <p className="text-gray-400 text-xs mt-1">{info.snippet}</p>}
            </div>
          ))}
        </div>
      </div>
    )}

    {isLoading && (
      <div className="flex items-center gap-2 text-gray-500 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" />
        Loading additional details...
      </div>
    )}
  </div>
);
